import "./component.scss";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {}
